/**
 * i18n-лейблы и тоны бейджей модуля «Поставщики».
 *
 * Состояние KYC — закрытая таксономия бэка
 * (internal/vendor_module/domain.KYCState). Сырые англ-коды НЕ показываем
 * (feedback_build_to_design_not_api_i18n_mobile) — мапим в русский.
 */

/** Состояние проверки поставщика (KYC) → русский лейбл. */
export const KYC_STATE_LABEL: Readonly<Record<string, string>> = {
  pending_review: 'На проверке',
  approved: 'Подтверждён',
  rejected: 'Отклонён',
  suspended: 'Приостановлен',
};

/** Состояние KYC → тон бейджа (.fleet-badge--*). */
export const KYC_STATE_TONE: Readonly<Record<string, string>> = {
  pending_review: 'warn',
  approved: 'ok',
  rejected: 'danger',
  suspended: 'muted',
};

export function kycStateLabel(state: string): string {
  return KYC_STATE_LABEL[state] ?? state;
}

export function kycStateTone(state: string): string {
  return KYC_STATE_TONE[state] ?? 'muted';
}

/** Фильтры по состоянию KYC для UI-чипов (значение пусто = все). */
export const KYC_FILTERS: ReadonlyArray<{ value: string; label: string }> = [
  { value: '', label: 'Все' },
  { value: 'approved', label: 'Подтверждённые' },
  { value: 'pending_review', label: 'На проверке' },
  { value: 'rejected', label: 'Отклонённые' },
  { value: 'suspended', label: 'Приостановленные' },
];

/** Инициалы для аватара-плашки поставщика по названию. */
export function vendorInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '—';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
}
